import { func, array, bool } from 'prop-types'
import { Asset, renderIcon, kuiperClassNames } from '@opallabs/kuiper'
import { ContentTextInput } from '../../../ContentTextInput'
import { styles } from './styles'

export const SnapchatPhoto = ({
  assets,
  isPresenting = false,
  onExpandAsset,
  onRemoveAsset,
  readOnly = false,
  updateCaption,
}) => {
  const photo = assets && assets[0]
  const showCaption = Boolean(photo && (!readOnly || photo.caption))

  if (photo) {
    return (
      <div
        css={styles.base({ empty: false })}
        className={kuiperClassNames('snapchat', 'snapchat-photo')}
      >
        <Asset
          assetReference={photo}
          imageFit="cover"
          hasAssetOverlay={!readOnly || isPresenting}
          onEmbiggen={() => onExpandAsset(photo.id)}
          onRemove={() => onRemoveAsset(photo.id)}
          removeable={!isPresenting}
        />
        {showCaption && (
          <ContentTextInput
            maxRows={3}
            minRows={1}
            onChange={(value) => updateCaption(value, photo.id)}
            placeholder={readOnly ? '' : 'Add caption...'}
            inputStyle={styles.input}
            placeholderStyle={styles.inputPlaceholder}
            readOnly={readOnly}
            style={styles.editorRoot}
            textAlign="center"
            value={photo.caption || ''}
          />
        )}
      </div>
    )
  }

  return (
    <div
      css={styles.base({ readOnly: readOnly && !isPresenting, empty: true })}
      className={kuiperClassNames('snapchat', 'snapchat-photo')}
    >
      {renderIcon('channel-snapchat', { ariaMode: 'hidden' })}
    </div>
  )
}

SnapchatPhoto.propTypes = {
  assets: array,
  isPresenting: bool,
  onExpandAsset: func,
  onRemoveAsset: func,
  readOnly: bool,
  updateCaption: func,
}
